export const content = {
  imageAlt: 'Oops, Page not found',
  title: 'Oops, Page not found',
  message: "The page you are looking for doesn't exist or has been moved.",
  signoff: '\u2014 The SMARTY team.',
  goToWebsitePrefix: 'Go to ',
  goToWebsiteLabel: 'smarty.co.uk',
}
